import { PunkParsedGameData } from "../../../server/data/PunkParsedGameData";
import { StateSymbolWin } from "../../independent/symbol/StateSymbolWin";
import { PunkGameModuleConfig } from "../../../PunkGameModuleConfig";
import { IAllWinData, IPunkBetWinData } from "../../../server/data/PunkServerData";
import { TimelineMax } from "gsap";
import { JumpingWildController, JumpWildState } from "../../independent/jumpingWild/JumpingWildController";
import { ReelAnimationManager } from "../../independent/reelAnimator/ReelAnimationManager";
import { PunkBackground } from "../../../background/PunkBackground";
import { ReelGraphicBackground } from "../../independent/background/ReelGraphicBackground";
import { PosterManager, PosterStates } from "../../independent/Poster/PosterManager";
import { PunkParsedInitData } from "../../../server/data/PunkParsedInitData";
import { SoundManager } from "../../../resource/sound/SoundManager";
import { SoundConfig } from "../../../SoundConfig";
import { WinCounter } from "../../independent/countup/WinCounter";
import { Presentation, PresentationState } from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import { GameMode } from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import { PunkEngineManager } from "../../../punkEngine/PunkEngineManager";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { ReelSymbolStates } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/ReelSpriteSymbolArea";
import { ReelSlicedDivider } from "../../independent/divider/ReelSlicedDivider";
import { ArrayHelper } from '@nolimitcity/slot-game/bin/core/utils/ArrayHelper';
import { SlotGame } from '@nolimitcity/slot-game/bin/core/SlotGame';
import { PunkRocker } from "../../../PunkRocker";

export class IdleWinPresentationManager extends Presentation {

    private featurePlayed:boolean = false;
    private respinFeature:boolean = false;
    private firstTrigger:boolean = true;

    private  _gameData:PunkParsedGameData;
    private _allHits:IAllWinData;
    private _idleTimeline:TimelineMax | null;

    protected posterHit:boolean = false;
    protected posterCounter:number = 0;
    protected _noWinPosters:string[] = [PosterStates.BOLLOCKS,PosterStates.SHIT_GAME,PosterStates.QUEEN]

    // protected _blowMyGame:TimelineMax;

    public get JuriGFXUSSettings():boolean {
        return !!PunkRocker.api.gameClientConfiguration.useCensoredGfxUS;
    }

    public setParsedInitData(data:PunkParsedInitData):void{
        if(data.mode == GameMode.NORMAL && data.nextMode == GameMode.NORMAL)
            this.PresentationState.set(PresentationState.ACTIVATED);

        this.firstTrigger = data.nextMode == GameMode.NORMAL;

        this._noWinPosters = ArrayHelper.shuffle(this._noWinPosters);
        if(this.JuriGFXUSSettings){
            this._noWinPosters = this._noWinPosters.filter(v => v != PosterStates.SHIT_GAME)
        }
    }

    public setParsedGamedData(data:PunkParsedGameData){
        this.featurePlayed = (data.mode != GameMode.NORMAL && data.nextMode == GameMode.NORMAL);
        this.respinFeature = (data.mode == GameMode.RESPIN && data.nextMode == GameMode.NORMAL);
        this._gameData = data;
        this._allHits = data.allWinData;

        if(data.isBigWin || this.featurePlayed) this.posterHit = false;
            
        if(data.singleWin == 0){
            let wildCount:number = 0;
            let mysteryCount:number = 0;

            if(this.featurePlayed && data.mode == GameMode.RESPIN){
                this.posterHit = true;
            }
            else if(!this.featurePlayed && data.wildExpands){
                data.wildLandPositions.forEach(pos => {if(pos >= 0) wildCount++});
                if(wildCount >= 2) this.posterHit = true;
            }
            else if(!this.featurePlayed && data.mysteryData!.mysterySymbolAppeared){
                data.mysteryData!.mysterySymbolOnReel.forEach(lands => {if(lands) mysteryCount++});
                if(mysteryCount >= 3) this.posterHit = true;
            }
            else if(wildCount + mysteryCount >= 3){
                this.posterHit = true;
            }
        }
    }

    public checkForActivation(data:PunkParsedGameData):boolean{ return data.nextMode == GameMode.NORMAL; }

    // Check the condition at PresentationController Play();
    public getPresentation():void {
        this.PresentationState.set(PresentationState.END);


        if(this.firstTrigger){
            SoundManager.reset();
            PunkEngineManager.RAll((Reel:number) => ReelSlicedDivider.instance.addDividers(false,Reel));
            this.firstTrigger = false;
            ReelAnimationManager.bonusReel.IdleEnabling();
            return;
        }
        
        this.pTimeline.add(PosterManager.instance.playSirene(false));
  
        if(!this.featurePlayed) ReelAnimationManager.bonusReel.IdleEnabling();
        else SoundManager.reset();

        if(this.posterHit) this.playNoWin();
        if(this._gameData.punkBetWins.length > 0)
            this.addWinCountUpToTimeline();
        else{
            PunkBackground.instance.changeGraphicAlpha(0.3,0);
        }
    }

    protected playNoWin():void{
        this.posterHit = false;
        PosterManager.instance.playNoWinPoster(this._noWinPosters[this.posterCounter]);
        this.posterCounter++;
        this.posterCounter = this.posterCounter%this._noWinPosters.length;
        this.pTimeline.to(this,0.750,{});
    }

    protected addWinCountUpToTimeline():void {
        StateSymbolWin.instance.resetIdleTimeline();
        this._idleTimeline = new TimelineMax({
            repeat: -1,
            repeatDelay: 0,
        });
        const delay:number = 2;
        const duration:number = 1.2;
        this._idleTimeline.to(this,2,{});
        this._idleTimeline.fromTo(ReelGraphicBackground.instance,duration*0.2,{alpha:0},{alpha:0.5},delay);
        this._idleTimeline.add(() => WinCounter.normalCounter.alpha = 1, delay)

        for(let groups = 0; groups < this._gameData.punkBetWins.length;groups++){
            const winData:IPunkBetWinData = this._gameData.punkBetWins[groups];
            for(let reel = 0; reel < winData.reelWinPositions.length;reel++){
                let posRow:boolean[] = winData.reelWinPositions[reel];
                for(let row = 0; row < posRow.length; row++){
                    if(JumpingWildController.instance.itemExists(reel,row) == -1){
                        if(posRow[row]){
                            this._idleTimeline.add(() => StateSymbolWin.instance.playIdleSymbolWinAnimation({
                                ReelID:reel,
                                SymID: row,
                                duration: duration,
                                State:ReelSymbolStates.WIN
                            }),delay + (groups*duration))
                        }
                    }
                }
            }
            this._idleTimeline.add([
                () => WinCounter.normalCounter.showCounter(winData.amount),
                () => WinCounter.winWayCounter.updateWinWays(winData.numberOfCombinations),
                () => WinCounter.winWayCounter.showWaysWonInst(),
            ],delay + (groups*duration))
        }

        if(this._gameData.punkBetWins.length > 1){
            for(let reel = 0; reel < this._allHits.reelWinPositions.length; reel++){
                for(let row = 0; row < this._allHits.reelWinPositions[reel].length;row++){
                    if(this._allHits.reelWinPositions[reel][row]){
                        if(JumpingWildController.instance.itemExists(reel,row) == -1){
                            this._idleTimeline.add(() => StateSymbolWin.instance.playIdleSymbolWinAnimation({
                                ReelID:reel,
                                SymID: row,
                                duration: duration,
                                State: ReelSymbolStates.WIN
                            }),delay + (this._gameData.punkBetWins.length*duration))
                        }
                    }
                }
            }
        }

        this._idleTimeline.add([
            () => WinCounter.normalCounter.showCounter(this._gameData.singleWin),
            () => WinCounter.winWayCounter.updateWinWays(this._allHits.totalWinCombination)
        ], delay + (this._gameData.punkBetWins.length*duration));

        this._idleTimeline.add(() => WinCounter.normalCounter.abort(this._gameData.singleWin),"+=0.3");
        
        let totalDurr:number = this._idleTimeline.duration();
        this._idleTimeline.to(ReelGraphicBackground.instance, 0.3,{alpha:0},totalDurr-(duration*0.4));
        this._idleTimeline.play();
    }

    public stopPresentation():void{ this.PresentationState.set(PresentationState.END); }

    public endPresentation():void {
        StateSymbolWin.instance.resetIdleTimeline();
        if(this.featurePlayed){
            if(!this.respinFeature){
                SoundManager.playSoundEffect(SoundConfig.instance.WILD_MOVES);
                for(let jw:number = 0; jw < JumpingWildController.instance.items.length; jw++){
                    this.pTimeline.add(JumpingWildController.instance.JumpTo({
                        ID: jw,
                        to:{reel: ReelAnimationManager.bonusReel.ReelID, row: jw%PunkEngineManager.getReel(5).AllWindowSymbols.length },
                        duration:0.6,
                        state: JumpWildState.IDLE
                    }),0)
                }
                PunkGameModuleConfig.xWayCounter.totalWinMorse(0.6,false);
            }
            this.pTimeline.add(() => StateSymbolWin.instance.fadeOutMult(5));
            this.pTimeline.add(() => JumpingWildController.instance.cleanItems());
            this.pTimeline.add(ReelAnimationManager.bonusReel.playEnd());
        }

        PunkGameModuleConfig.xWayCounter.setValue(undefined,Math.pow(3,5),0.4);
        PunkGameModuleConfig.xWayCounter.stopLoop();

        if(this._idleTimeline){
            ReelGraphicBackground.instance.alpha = 0;
            this._idleTimeline = Helper.timeLineNuller(this._idleTimeline);
            WinCounter.winWayCounter.updateWinWays(this._allHits.totalWinCombination);
            WinCounter.normalCounter.abort(this._gameData!.singleWin);
        }

        PunkEngineManager.RSWindow((reel:number,sym:number) => {PunkEngineManager.getReel(reel).getSymbol(sym)!.setVisibleForSymbol(true);})
        ReelAnimationManager.bonusReel.IdleDisabling();
        PunkBackground.instance.changeGraphicAlpha(0.3,0);
        this.PresentationState.set(PresentationState.INACTIVE);
    }
}